/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  // Prestige はバリアント変更時にポップオーバーのラベルとボタン価格を更新するが、
  // カート送信は select[name="id"].value を参照する。テーマが variant:changed を
  // 発火したタイミングで hidden select を同期する（Prestige custom.js ヘッダー参照）。
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var form = (event.target && event.target.closest('.ProductForm')) || document.querySelector('.ProductForm');
    if (!form) return;

    var select = form.querySelector('select[name="id"]');
    if (!select || String(select.value) === String(variant.id)) return;

    select.value = String(variant.id);
  });

  // 外部リンク対応
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].relList.add('noreferrer', 'noopener');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    // ヘッダーの検索フォーム対応
    const input = document.querySelector('.js-search-input')
    if (input) {
      const query = Qs.parse(location.search.replace('?', ''))
      if (query.q) {
        input.value = query.q
      }
    }

    // ヘッダーのタレント一覧
    const toggleCategoryList = document.querySelectorAll('.js-toggle-category-list')
    if (toggleCategoryList) {
      toggleCategoryList.forEach(el => {
        el.addEventListener('click', (e) => {
          const id = e.target.dataset.rowId
          const targetList = document.querySelector(`.category-children-list[data-parent-id="${id}"]`)

          if (targetList) {
            targetList.classList.toggle('active')
          }

          if (e.target.classList.contains('downward')) {
            e.target.classList.remove('downward')
            e.target.classList.add('upward')
          } else {
            e.target.classList.remove('upward')
            e.target.classList.add('downward')
          }
        })
      })
    }

    // ヘッダーのタレント一覧
    const toggleTalentList = document.querySelectorAll('.js-toggle-talent-list')
    if (toggleTalentList) {
      toggleTalentList.forEach(el => {
        el.addEventListener('click', (e) => {
          const id = e.target.dataset.rowId
          const targetList = document.querySelector(`.talent-child-list[data-parent-id="${id}"]`)
          const targettalentList = document.querySelector(`.talent-child-list-${id}`)

          if (targetList) {
            targetList.classList.toggle('active')
          } else if (targettalentList) {
            targettalentList.classList.toggle('active')
          }

          if (e.target.classList.contains('downward')) {
            e.target.classList.remove('downward')
            e.target.classList.add('upward')
          } else {
            e.target.classList.remove('upward')
            e.target.classList.add('downward')
          }
        })
      })
    }

    // お気に入り
    if (location.pathname.indexOf('/apps/favhero/favorites') === 0) {
      setTimeout(() => {
        const els = document.querySelectorAll('.chakra-button.favhero-product__add-to-card-button')
        if (els) {
          els.forEach(el => {
            el.className = 'ProductForm__AddToCart Button Button--secondary Button--full'
            el.style.display = 'none'
          })
        }
      }, 1000);
    }

    const gloNav1 = document.getElementById('js-nav-cat1');
    const gloAcd1 = document.getElementById('js-acd-cat1');
    const gloNav2 = document.getElementById('js-nav-cat2');
    const gloAcd2 = document.getElementById('js-acd-cat2');
    const gloNav3 = document.getElementById('js-nav-cat3');
    const gloAcd3 = document.getElementById('js-acd-cat3');
    gloNav1.addEventListener("click", () => {
      if (gloNav1.classList.contains('downward')) {
        gloNav1.classList.remove('downward');
        gloNav1.classList.add('upward');
        gloAcd1.classList.add('active');
      } else {
        gloNav1.classList.remove('upward');
        gloNav1.classList.add('downward');
        gloAcd1.classList.remove('active');
      }
      gloNav2.classList.remove('upward');
      gloNav2.classList.add('downward');
      gloAcd2.classList.remove('active');
      gloNav3.classList.remove('upward');
      gloNav3.classList.add('downward');
      gloAcd3.classList.remove('active');
    });
    gloNav2.addEventListener("click", () => {
      if (gloNav2.classList.contains('downward')) {
        gloNav2.classList.remove('downward');
        gloNav2.classList.add('upward');
        gloAcd2.classList.add('active');
      } else {
        gloNav2.classList.remove('upward');
        gloNav2.classList.add('downward');
        gloAcd2.classList.remove('active');
      }
      gloNav1.classList.remove('upward');
      gloNav1.classList.add('downward');
      gloAcd1.classList.remove('active');
      gloNav3.classList.remove('upward');
      gloNav3.classList.add('downward');
      gloAcd3.classList.remove('active');
    });
    gloNav3.addEventListener("click", () => {
      if (gloNav3.classList.contains('downward')) {
        gloNav3.classList.remove('downward');
        gloNav3.classList.add('upward');
        gloAcd3.classList.add('active');
      } else {
        gloNav3.classList.remove('upward');
        gloNav3.classList.add('downward');
        gloAcd3.classList.remove('active');
      }
      gloNav1.classList.remove('upward');
      gloNav1.classList.add('downward');
      gloAcd1.classList.remove('active');
      gloNav2.classList.remove('upward');
      gloNav2.classList.add('downward');
      gloAcd2.classList.remove('active');
    });
  });
}())

 var links = document.links;
 for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
   if (links[i].hostname !== window.location.hostname) {
     links[i].target = '_blank';
     links[i].relList.add('noreferrer', 'noopener');
   }
 }